import React from "react";
import { useState, useContext, useEffect } from "react";

import {
  Grid,
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Input,
  IconButton,
} from "@material-ui/core";
import CheckCircleRoundedIcon from "@material-ui/icons/CheckCircleRounded";

import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import EditIcon from "@material-ui/icons/Edit";

//Styles
import useStyles from "./styles";

//Context
import { AsesoresContext } from "../../views/asesores/context";
import { APIContext } from "../../../context";

//hook
import useFormValidation from "../../../hooks/formValidation";
import validateAsesorForm from "./validations";
import validateAsesorFormUpdate from "./validations2";

const AsesorDialogForm = ({ dialogOpen, handleClose, array, edit }) => {
  const classes = useStyles();

  const [showPassword, setShowPassword] = useState(false);
  // Vehiculo Context
  const { form, tipo_ide, rol, estado } = useContext(AsesoresContext);

  //APIContext
  const { asesores, createAsesor, listAsesores, updateAsesor } =
    useContext(APIContext);

  const funct = edit ? updateAsesor : createAsesor;
  const validation = edit ? validateAsesorFormUpdate : validateAsesorForm;
  if (!edit) {
    form["ase_estado"] = 1;
  }
  // Validation Hook
  const {
    fields,
    setFields,
    errors,
    handleSubmit,
    handleChange,
    handleBlur,
    clearFields,
    clearErrors,
    readyToSubmit,
  } = useFormValidation(form, validation, funct, handleClose);

  const [clearer, setClearer] = useState(null);
  const [updatedFields, setUpdatedFields] = useState([]);
  const [active, setactive] = useState(null);

  const [enabledFields, setEnabledFields] = useState({
    ase_nombre: true,
    password: true,
    ase_tipide: true,
    ase_numide: true,
    ase_email: true,
    ase_telefono: true,
    ase_telefono2: true,
    ase_rol: true,
    ase_estado: true,
  });

  useEffect(() => {
    if (asesores.length === 0) {
      listAsesores();
    }
  }, []);

  useEffect(() => {
    if (edit && array[0]) {
      setFields(array[0]);
    }
  }, [array]);

  useEffect(() => {
    if (clearer === true) {
      clearFields();
      clearErrors();
      setClearer(false);
    }
  }, [clearer, errors]);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const cleanEnabledFields = () => {
    setEnabledFields({
      ase_nombre: true,
      password: true,
      ase_tipide: true,
      ase_numide: true,
      ase_email: true,
      ase_telefono: true,
      ase_telefono2: true,
      ase_rol: true,
      ase_estado: true,
    });
  };
  return (
    <>
      <Dialog
        open={dialogOpen}
        onClose={() => {
          handleClose();
          setClearer(true);
          cleanEnabledFields();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={"md"}
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-aprobar-causa-title">
          <Grid container spacing={3} justifyContent="space-between">
            <Grid item xs={12} md={9} lg={9}>
              {edit ? `Asesor ${fields.ase_nombre}` : "Crear nuevo registro"}
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent dividers>
          <div className={classes.root}>
            <Grid container spacing={3} justifyContent="space-between">
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  id="ase_nombre"
                  name="ase_nombre"
                  label="Nombre Completo"
                  value={fields.ase_nombre || ""}
                  onChange={(e) => {
                    handleChange(e);
                    if (!updatedFields.includes("ase_nombre")) {
                      setUpdatedFields([...updatedFields, "ase_nombre"]);
                    }
                  }}
                  onBlur={(e) => {
                    handleBlur(e);
                    cleanEnabledFields();
                  }}
                  autoFocus
                  error={"ase_nombre" in errors}
                  helperText={
                    "ase_nombre" in errors
                      ? errors.ase_nombre
                      : "Nombre del asesor"
                  }
                  onMouseOver={() => {
                    setactive("ase_nombre");
                  }}
                  onMouseLeave={() => {
                    setactive(null);
                  }}
                  InputProps={{
                    readOnly: enabledFields.ase_nombre && edit,
                    endAdornment: (
                      <>
                        {active === "ase_nombre" && edit && (
                          <InputAdornment position="start">
                            <IconButton
                              aria-label="edit"
                              className={classes.margin}
                              onClick={() => {
                                setEnabledFields({
                                  ...enabledFields,
                                  ase_nombre: false,
                                });
                                document.getElementById("ase_nombre").focus();
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        )}
                      </>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <FormControl
                  className={classes.formControl}
                  error={"ase_tipide" in errors}
                >
                  <InputLabel id="select-label">
                    Tipo de identificación
                  </InputLabel>
                  <Select
                    autoWidth
                    labelId="select-label"
                    id="ase_tipide"
                    name="ase_tipide"
                    value={fields.ase_tipide ? fields.ase_tipide : ""}
                    onChange={(e) => {
                      handleChange(e);
                      if (!updatedFields.includes("ase_tipide")) {
                        setUpdatedFields([...updatedFields, "ase_tipide"]);
                      }
                    }}
                    onBlur={(e) => {
                      handleBlur(e);
                      cleanEnabledFields();
                    }}
                    onMouseOver={() => {
                      setactive("ase_tipide");
                    }}
                    onMouseLeave={() => {
                      setactive(null);
                    }}
                    readOnly={enabledFields.cli_tipide && edit}
                    endAdornment={
                      <>
                        {active === "ase_tipide" && edit && (
                          <InputAdornment position="start">
                            <IconButton
                              aria-label="edit"
                              className={classes.margin}
                              onClick={() => {
                                setEnabledFields({
                                  ...enabledFields,
                                  ase_tipide: false,
                                });
                                document.getElementById("ase_tipide").focus();
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        )}
                      </>
                    }
                  >
                    {tipo_ide.map((tipo) => (
                      <MenuItem key={tipo.tipo + tipo.value} value={tipo.value}>
                        {tipo.tipo}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>
                    {"ase_tipide" in errors
                      ? errors.ase_tipide
                      : "Seleccione el tipo de identificación"}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField
                  fullWidth
                  id="ase_numide"
                  name="ase_numide"
                  label="Número de identificación"
                  value={fields.ase_numide || ""}
                  onChange={(e) => {
                    handleChange(e);
                    if (!updatedFields.includes("ase_numide")) {
                      setUpdatedFields([...updatedFields, "ase_numide"]);
                    }
                  }}
                  onBlur={(e) => {
                    handleBlur(e);
                    cleanEnabledFields();
                  }}
                  error={"ase_numide" in errors}
                  helperText={
                    "ase_numide" in errors
                      ? errors.ase_numide
                      : "Número de identificación"
                  }
                  onMouseOver={() => {
                    setactive("ase_numide");
                  }}
                  onMouseLeave={() => {
                    setactive(null);
                  }}
                  InputProps={{
                    readOnly: enabledFields.ase_numide && edit,
                    endAdornment: (
                      <>
                        {active === "ase_numide" && edit && (
                          <InputAdornment position="start">
                            <IconButton
                              aria-label="edit"
                              className={classes.margin}
                              onClick={() => {
                                setEnabledFields({
                                  ...enabledFields,
                                  ase_numide: false,
                                });
                                document.getElementById("ase_numide").focus();
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        )}
                      </>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={6} sm={6}>
                <TextField
                  fullWidth
                  id="ase_email"
                  name="ase_email"
                  label="Email"
                  value={fields.ase_email || ""}
                  onChange={(e) => {
                    handleChange(e);
                    if (!updatedFields.includes("ase_email")) {
                      setUpdatedFields([...updatedFields, "ase_email"]);
                    }
                  }}
                  onBlur={(e) => {
                    handleBlur(e);
                    cleanEnabledFields();
                  }}
                  error={"ase_email" in errors}
                  helperText={
                    "ase_email" in errors
                      ? errors.ase_email
                      : "Email del asesor"
                  }
                  onMouseOver={() => {
                    setactive("ase_email");
                  }}
                  onMouseLeave={() => {
                    setactive(null);
                  }}
                  InputProps={{
                    readOnly: enabledFields.ase_email && edit,
                    endAdornment: (
                      <>
                        {active === "ase_email" && edit && (
                          <InputAdornment position="start">
                            <IconButton
                              aria-label="edit"
                              className={classes.margin}
                              onClick={() => {
                                setEnabledFields({
                                  ...enabledFields,
                                  ase_email: false,
                                });
                                document.getElementById("ase_email").focus();
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        )}
                      </>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={6} sm={6}>
                {!edit && (
                  <FormControl
                    className={classes.formControl}
                    error={"password" in errors}
                  >
                    <InputLabel htmlFor="password">Contraseña</InputLabel>
                    <Input
                      id="password"
                      name="password"
                      type={showPassword ? "text" : "password"}
                      value={fields.password || ""}
                      onChange={(e) => {
                        handleChange(e);
                        if (!updatedFields.includes("password")) {
                          setUpdatedFields([...updatedFields, "password"]);
                        }
                      }}
                      onBlur={(e) => {
                        handleBlur(e);
                        cleanEnabledFields();
                      }}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            size="medium"
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                    <FormHelperText>
                      {"password" in errors
                        ? errors.password
                        : "Escriba la contraseña del asesor"}
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>

              <Grid item xs={6} sm={3}>
                <TextField
                  fullWidth
                  id="ase_telefono"
                  name="ase_telefono"
                  label="Teléfono"
                  value={fields.ase_telefono || ""}
                  onChange={(e) => {
                    handleChange(e);
                    if (!updatedFields.includes("ase_telefono")) {
                      setUpdatedFields([...updatedFields, "ase_telefono"]);
                    }
                  }}
                  onBlur={(e) => {
                    handleBlur(e);
                    cleanEnabledFields();
                  }}
                  error={"ase_telefono" in errors}
                  helperText={
                    "ase_telefono" in errors
                      ? errors.ase_telefono
                      : "Primer teléfono del asesor"
                  }
                  onMouseOver={() => {
                    setactive("ase_telefono");
                  }}
                  onMouseLeave={() => {
                    setactive(null);
                  }}
                  InputProps={{
                    readOnly: enabledFields.ase_telefono && edit,
                    endAdornment: (
                      <>
                        {active === "ase_telefono" && edit && (
                          <InputAdornment position="start">
                            <IconButton
                              aria-label="edit"
                              className={classes.margin}
                              onClick={() => {
                                setEnabledFields({
                                  ...enabledFields,
                                  ase_telefono: false,
                                });
                                document.getElementById("ase_telefono").focus();
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        )}
                      </>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField
                  fullWidth
                  id="ase_telefono2"
                  name="ase_telefono2"
                  label="Teléfono 2"
                  value={fields.ase_telefono2 || ""}
                  onChange={(e) => {
                    handleChange(e);
                    if (!updatedFields.includes("ase_telefono2")) {
                      setUpdatedFields([...updatedFields, "ase_telefono2"]);
                    }
                  }}
                  onBlur={(e) => {
                    handleBlur(e);
                    cleanEnabledFields();
                  }}
                  error={"ase_telefono2" in errors}
                  helperText={
                    "ase_telefono2" in errors
                      ? errors.ase_telefono2
                      : "Segundo teléfono del asesor"
                  }
                  onMouseOver={() => {
                    setactive("ase_telefono2");
                  }}
                  onMouseLeave={() => {
                    setactive(null);
                  }}
                  InputProps={{
                    readOnly: enabledFields.ase_telefono2 && edit,
                    endAdornment: (
                      <>
                        {active === "ase_telefono2" && edit && (
                          <InputAdornment position="start">
                            <IconButton
                              aria-label="edit"
                              className={classes.margin}
                              onClick={() => {
                                setEnabledFields({
                                  ...enabledFields,
                                  ase_telefono2: false,
                                });
                                document
                                  .getElementById("ase_telefono2")
                                  .focus();
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        )}
                      </>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={6} sm={6}>
                <FormControl
                  className={classes.formControl}
                  error={"ase_rol" in errors}
                >
                  <InputLabel id="select-label">Rol</InputLabel>
                  <Select
                    autoWidth
                    labelId="select-label"
                    id="ase_rol"
                    name="ase_rol"
                    value={fields.ase_rol ? fields.ase_rol : ""}
                    onChange={(e) => {
                      handleChange(e);
                      if (!updatedFields.includes("ase_rol")) {
                        setUpdatedFields([...updatedFields, "ase_rol"]);
                      }
                    }}
                    onBlur={(e) => {
                      handleBlur(e);
                      cleanEnabledFields();
                    }}
                    onMouseOver={() => {
                      setactive("ase_rol");
                    }}
                    onMouseLeave={() => {
                      setactive(null);
                    }}
                    //readOnly={enabledFields.ase_rol && edit}
                    endAdornment={
                      <>
                        {active === "ase_rol" &&
                          edit &&
                          fields.ase_rol !== 1 && (
                            <InputAdornment position="start">
                              <IconButton
                                aria-label="edit"
                                className={classes.margin}
                                onClick={() => {
                                  setEnabledFields({
                                    ...enabledFields,
                                    ase_rol: false,
                                  });
                                  document.getElementById("ase_rol").focus();
                                }}
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </InputAdornment>
                          )}
                      </>
                    }
                  >
                    {rol.map((rol) => (
                      <MenuItem key={rol.tipo + rol.value} value={rol.value}>
                        {rol.tipo}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>
                    {"ase_rol" in errors
                      ? errors.ase_rol
                      : "Seleccione el rol del asesor"}
                  </FormHelperText>
                </FormControl>
              </Grid>
              {edit && (
                <Grid item xs={6} sm={6}>
                  <FormControl
                    className={classes.formControl}
                    error={"ase_estado" in errors}
                  >
                    <InputLabel id="select-label">Estado</InputLabel>
                    <Select
                      autoWidth
                      labelId="select-label"
                      id="ase_estado"
                      name="ase_estado"
                      value={fields.ase_estado ? fields.ase_estado : ""}
                      onChange={(e) => {
                        handleChange(e);
                        if (!updatedFields.includes("ase_estado")) {
                          setUpdatedFields([...updatedFields, "ase_estado"]);
                        }
                      }}
                      onBlur={(e) => {
                        handleBlur(e);
                        cleanEnabledFields();
                      }}
                      onMouseOver={() => {
                        setactive("ase_estado");
                      }}
                      onMouseLeave={() => {
                        setactive(null);
                      }}
                      readOnly={enabledFields.cli_tipide && edit}
                      endAdornment={
                        <>
                          {active === "ase_estado" && edit && (
                            <InputAdornment position="start">
                              <IconButton
                                aria-label="edit"
                                className={classes.margin}
                                onClick={() => {
                                  setEnabledFields({
                                    ...enabledFields,
                                    ase_estado: false,
                                  });
                                  document.getElementById("ase_estado").focus();
                                }}
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </InputAdornment>
                          )}
                        </>
                      }
                    >
                      {estado.map((estado) => (
                        <MenuItem
                          key={estado.tipo + estado.value}
                          value={estado.value}
                        >
                          {estado.tipo}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>
                      {"ase_estado" in errors
                        ? errors.ase_estado
                        : "Seleccione el estado del asesor"}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              )}
            </Grid>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleClose();
              setClearer(true);
              cleanEnabledFields();
            }}
            color="secondary"
          >
            Cancelar
          </Button>
          {edit ? (
            <Button
              //type="submit"
              variant="contained"
              color="primary"
              disabled={!readyToSubmit}
              onClick={(e) => {
                handleSubmit(e);
                handleClose();
                setClearer(true);
                cleanEnabledFields();
              }}
            >
              <CheckCircleRoundedIcon />
              Guardar Cambios
            </Button>
          ) : (
            <Button
              //type="submit"
              variant="contained"
              color="primary"
              disabled={!readyToSubmit}
              onClick={(e) => {
                handleSubmit(e);
                handleClose();
                setClearer(true);
              }}
            >
              <CheckCircleRoundedIcon />
              Guardar
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};
export default AsesorDialogForm;
